import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import Accounts from './containers/Accounts/index.ts';

const CRM = {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  Accounts,
  ContactForm: lazy(() => import('./containers/Contacts/containers/ContactForm/index.tsx')),
  Contacts: lazy(() => import('./containers/Contacts/index.tsx')),
  ContactHistory: lazyNamed(() => import('./containers/Contacts/containers/History/index.tsx'), 'History'),
  Settings: {
    Layout: lazyNamed(() => import('./containers/Settings/components/Layout.tsx'), 'Layout'),
    LockedFields: lazyNamed(() => import('./containers/Settings/containers/LockedFields/index.tsx'), 'LockedFields'),
  },
};

export default CRM;
export { ContactFormSearchParams } from './types.ts';
